import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ContractObservationView } from "./ContractObservationView";
import { ContractObservationViewStore } from "../../store/ContractObservationViewStore";
import { useStore } from "../../../../hooks";

export const ContractObservationViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/contractObservation/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ContractObservationViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "filters",
              label: rootStore.langStore.groupContractObservationFiltersLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ContractObservationView contractObservationViewStore={store} />
      </PageLayout>
    </div>
  );
});
